import { autoWebViewJs } from "../../AutoWebViewJs";

function read2<T>(key:string, defaultValue?:T):T{
    let script = `var v = com.fanfanlo.lib.store.SharedPrefs.read("${key}");\n v;`
    // console.log('autojs store utils read script=', script)
    let {javaResultString:v, error} = autoWebViewJs.callScript<string>(script)
    // console.log('read_fn key=', key, 'java result string', v,)
    if(v){

            let s = "";
            try{
                s= window.atob(v) ;
                v = s;
                try{
                    let x = JSON.parse(s);
                    // console.log('read', 'x=', x, 'script=', script)
                    return x as T;
                }catch(e){

                    // console.log('script =', script)
                    // console.log('value =', v);
                    // console.log("storage get item json.parse error,but maybe not an error", e);
                }
            }catch(e){
                console.log('atob error', e, 'v=', v, 'script=', script)
                console.trace('atob error')
                v = undefined
            }
    }
    // console.log('return default', `key=${key}`, defaultValue)
    return typeof defaultValue === 'undefined' ? v as T : defaultValue as T;
    // return defaultValue || (v as T);
}

function write2<T>(key:string ,v:T){
    try{
    // console.log('autojs store utils write', 'key=', key, JSON.stringify(v))
    const s = window.btoa(JSON.stringify(v))
    // console.log('autojs store utils write', 's=', s)
    let script = `var v = com.fanfanlo.lib.store.SharedPrefs.write("${key}", "${s}");`;
    // console.log('auto js store utils write', 'script=', script)
    autoWebViewJs.callScript(script);
    // console.log('autoJsStoreUtils write', 'key=', key, 's=', s, 'script=', script)
    }catch(e){
        console.error(`autoJsStoreUtils write error`, (e as any)?.message);
        console.error(`autoJsStoreUtils write error`, e);
    }
}

function read<T>(key:string, defaultValue?:T):T{
    let script = `var v = com.fanfanlo.lib.store.SharedPrefs.read("${key}");\n v;`
    // console.log('autojs store utils read script=', script)
    let {javaResultString:v, error} = autoWebViewJs.callScript<string>(script)
    // console.log('read_fn key=', key, 'java result string', v,)
    if(v){

            let s = "";
            try{
                s= atobUtf8(v) ;
                v = s;
                try{
                    let x = JSON.parse(s);
                    // console.log('read', 'x=', x, 'script=', script)
                    return x as T;
                }catch(e){

                    // console.log('script =', script)
                    // console.log('value =', v);
                    // console.log("storage get item json.parse error,but maybe not an error", e);
                }
            }catch(e){
                console.log('atob error', e, 'v=', v, 'script=', script)
                console.trace('atob error')
                v = undefined
            }
    }
    // console.log('return default', `key=${key}`, defaultValue)
    return typeof defaultValue === 'undefined' ? v as T : defaultValue as T;
    // return defaultValue || (v as T);
}

function write<T>(key:string, v:T):void{
    try{

    // console.log('autojs store utils write', 'key=', key, JSON.stringify(v))
    const s = stringifyBtoaUtf8(v)
    // console.log('autojs store utils write', 's=', s)
    let script = `var v = com.fanfanlo.lib.store.SharedPrefs.write("${key}", "${s}");`;
    // console.log('auto js store utils write', 'script=', script)
    autoWebViewJs.callScript(script);
    // console.log('autoJsStoreUtils write', 'key=', key, 's=', s, 'script=', script)
    }catch(e){
        console.error(`autoJsStoreUtils write error`, (e as any)?.message);
        console.error(`autoJsStoreUtils write error`, e);
    }
}

function stringifyBtoaUtf8<T>(obj: T): string {
  const v = JSON.stringify(obj);
  return btoaUtf8(v);
}


function btoaUtf8(str:string): string {
  const utf8Bytes = new TextEncoder().encode(str);
  let binary = "";
  utf8Bytes.forEach(b => binary += String.fromCharCode(b));
  return btoa(binary);
}

function atobUtf8(base64:string): string {
  const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}
export const autoJsStoreUtils = {
    write,
    read,
    atobUtf8,
    btoaUtf8,
}